import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fsRealEnglish'
})
export class FLXRealEnglishPipe implements PipeTransform {
	public transform(input: string): string {
		if (!input) {
			return '';
		} else {
			let newString = input?.toLowerCase()?.replace(/-|_/gi, ' ');

			switch (newString) {
				case 'voluntaryexcess':
					newString = 'voluntary excess';
					break;
				case 'dontpingsp':
					newString = "don't ping sp";
					break;
				case 'areacode':
					newString = 'area code';
					break;
				case 'addressconfirmation':
					newString = 'address confirmation';
					break;
				case 'onsitecontact':
					newString = 'onsite contact';
					break;
				case 'dateofloss':
					newString = 'date of loss';
					break;
				case 'propertycomplex':
					newString = 'property complex';
					break;
				case 'propertycomplexunitnumber':
					newString = 'property complex unit number';
					break;
				case 'handleremail':
					newString = 'handler email';
					break;
				case 'mavenclearancecode':
					newString = 'maven clearance code';
					break;
				case 'claimtype':
					newString = 'claim type';
					break;
				case 'claimtype id':
					newString = 'claim type id';
					break;
				case 'additionalexcess':
					newString = 'additional excess';
					break;
				case 'contactnumber':
					newString = 'contact number';
					break;
				case 'mavenclaimnumber':
					newString = 'maven claim number';
					break;
				case 'onsiteperson':
					newString = 'onsite person';
					break;
				case 'onsitenotes':
					newString = 'onsite notes';
					break;
				case 'whatmatters':
					newString = 'what matters';
					break;
				case 'propertycity':
					newString = 'property city';
					break;
				case 'specialclause':
					newString = 'special clause';
					break;
				case 'preferedcommethod':
					newString = 'preferred com method';
					break;
				case 'isjointaccount':
					newString = 'is joint account';
					break;
				case 'claimlatitude':
					newString = 'claim latitude';
					break;
				case 'claimlongitude':
					newString = 'claim longitude';
					break;
				case 'handlercontact':
					newString = 'handler contact';
					break;
				case 'clientcode':
					newString = 'client code';
					break;
				case 'claimdescription':
					newString = 'claim description';
					break;
				case 'suminsured':
					newString = 'sum insured';
					break;
				case 'cellnumber':
					newString = 'cell number';
					break;
				case 'suburbcode':
					newString = 'suburb code';
					break;
				case 'propertystreetaddress':
					newString = 'property street address';
					break;
				case 'reinsuranceexcess':
					newString = 'reinsurance excess';
					break;
				case 'propertysuburb':
					newString = 'property suburb';
					break;
				case 'claimantpoliceynum':
					newString = 'claimant policy number';
					break;
				case 'bondnumber':
					newString = 'bond number';
					break;
				case 'requestedappointmenttime':
					newString = 'requested appointment time';
					break;
				case 'requestedappointmentdate':
					newString = 'requested appointment date';
					break;
				case 'requiredvendortype':
					newString = 'required vendor type';
					break;
				case 'appointmentdatetype':
					newString = 'appointment date type';
					break;
				case 'claimprovince':
					newString = 'claim province';
					break;
				case 'policecasenumber':
					newString = 'police case number';
					break;
				case 'skillrequested':
					newString = 'skill requested';
					break;
				case 'providertype':
					newString = 'provider type';
					break;
				case 'providertype id':
					newString = 'Provider type ID';
					break;
				case 'skillcatagory':
					newString = 'Skill Category';
					break;
				case 'skillcatagory id':
					newString = 'Skill Category ID';
					break;
				case 'ratingwecanimprove':
					newString = 'Rating We Can Improve';
					break;
				case 'ratingwhatwedidwell':
					newString = 'Rating What We Did Well';
					break;
				case 'whatmattersachieved':
					newString = 'What Matters Achieved';
					break;
				case 'policydetails':
					newString = 'Policy Details';
					break;
				case 'transactionnumber':
					newString = 'Transaction Number';
					break;
				case 'firstname':
					newString = 'First Name';
					break;
				case 'cellcaptive':
					newString = 'Cell Captive';
					break;
				case 'coverdescription':
					newString = 'Cover Description';
					break;
				case 'producttype':
					newString = 'Product Type';
					break;
				case 'productoptioncode':
					newString = 'Product Option Code';
					break;
				case 'cessioncode':
					newString = 'Cession Code';
					break;
				case 'underwritercode':
					newString = 'Underwriter code';
					break;
				case 'policystatusid':
					newString = 'Policy Status Id';
					break;
				case 'productcode':
					newString = 'Product Code';
					break;
				case 'covername':
					newString = 'Cover Name';
					break;
				case 'productoptionname':
					newString = 'Product Option Name';
					break;
				case 'accountname':
					newString = 'Account Name';
					break;
				case 'policystatus':
					newString = 'Policy Status';
					break;
				case 'contracturl':
					newString = 'Contract Url';
					break;
				case 'expirydate':
					newString = 'Expiry Date';
					break;
				case 'policynumber':
					newString = 'Policy Number';
					break;
				case 'organizationcode':
					newString = 'Organization Code';
					break;
				case 'productname':
					newString = 'Product Name';
					break;
				case 'idnumber':
					newString = 'Id Number';
					break;
				case 'emailaddress':
					newString = 'Email Address';
					break;
				case 'contractid':
					newString = 'Contract Id';
					break;
				case 'cellphonenumber':
					newString = 'Cellphone Number';
					break;
				case 'policyid':
					newString = 'Policy Id';
					break;
			}

			return newString;
		}
	}
}
